<template>
  <div :class="{card: !isIndividual}">
    <div class="card-header" v-if="!isIndividual">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'P Trends'}}</strong>
        </div>
        <div class="col-md-5">
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-primary" @click.prevent="editCompany(company)">
              <i :title="'Edit'" class="fa fa-edit cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-dark" to="/company-prices-graph">
              <i :title="'Company Price Graph'" class="fa fa-line-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-danger" to="/company-price-analysis">
              <i :title="'Price Analysis'" class="fa fa-money cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-info" to="/rawdata">
              <i :title="'Raw Data'" class="fa fa-list cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <a
              class="btn btn-sm btn-small btn-warning"
              @click.prevent="viewCalculatedData(company)"
            >
              <i :title="'Calculated Data'" class="fa fa-calculator cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-success" @click.prevent="showDetailView(company)">
              <i :title="'View Details'" class="fa fa-eye cwhite"></i>
            </a>
          </div>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb-15" v-if="isIndividual">
        <div class="col-md-9">
          <!-- <strong class="card-title mb-3">{{'P Trends'}}</strong> -->
        </div>
        <div class="col-md-3">
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-primary" @click.prevent="editCompany(company)">
              <i :title="'Edit'" class="fa fa-edit cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-dark" to="/company-prices-graph">
              <i :title="'Company Price Graph'" class="fa fa-line-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-danger" to="/company-price-analysis">
              <i :title="'Price Analysis'" class="fa fa-money cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-info" to="/rawdata">
              <i :title="'Raw Data'" class="fa fa-list cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <a
              class="btn btn-sm btn-small btn-warning"
              @click.prevent="viewCalculatedData(company)"
            >
              <i :title="'Calculated Data'" class="fa fa-calculator cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-success" @click.prevent="showDetailView(company)">
              <i :title="'View Details'" class="fa fa-eye cwhite"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group">
            <datepicker
              :input-class="'form-control'"
              :format="'dd-MM-yyyy'"
              v-model="fDate"
              @selected="getFDate($event)"
              :disabledDates="disabledDates"
            ></datepicker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <datepicker
              :input-class="'form-control'"
              :format="'dd-MM-yyyy'"
              v-model="toDate"
              @selected="getToDate($event)"
              :disabledDates="disabledDates"
            ></datepicker>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <button @click="getRawData" class="btn btn-sm btn-primary" type="button">
              <i class="fa fa-filter" title="Filter"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row mb5">
        <div class="col-md-6">
          <div class="form-group">
            <v-select
              :options="companyList"
              :placeholder="'Select Company'"
              :label="'companyname'"
              v-model="selComp"
              @input="getCompRawData"
            ></v-select>
          </div>
        </div>
        <div class="col-md-3">
          <!-- <select class="form-control" name="ptype" @change="getPdata" v-model="ptype" multiple >
                <option value>Select Data</option>
                <option
                  v-for="(p, index) in tableFields"
                  :value="p.title"
                  v-bind:key="p.title"
                >{{p.name}}</option>
          </select>-->
          <v-select
            :options="tableFields"
            :placeholder="'Select P\'s'"
            v-model="ptype"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            label="name"
            track-by="title"
            :preselect-first="true"
            select-label
            selectedLabel
            deselectLabel
            @input="getPdata"
          ></v-select>
        </div>
        <div class="col-md-1">
          <button type="button" class="btn btn-sm btn-success" @click="getDataSets">Go</button>
        </div>
      </div>

      <div class="row mb5">
        <div class="col-md-12" :id="'ptrend'">
          <canvas :id="'comprice'"></canvas>
        </div>
      </div>
      <div class="row mb-15">
        <div class="col-md-12"></div>
      </div>
      <hr />
      <div class="row mb5">
        <div class="col-md-12" v-dragscroll="true">
          <div class="table-responsive">
            <table class="table table-bordered fonts11" v-if="dataSets.length>0">
              <thead>
                <tr>
                  <th></th>
                  <th>{{groupLabels[0]}}</th>
                  <th>{{groupLabels[avg]}}</th>
                  <th>{{groupLabels[groupLabels.length-1]}}</th>
                  <!-- <th
                    v-for="(field, index) in tableFields"
                    :key="'ptrend-head'+index"
                  >{{field.name}}</th>-->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(field, index) in tableFields" :key="'ptrend-first'+index">
                  <td>{{field.name}}</td>
                  <td>{{(rawData[field.title][0])? getFixed(rawData[field.title][0][field.title]): ''}}</td>
                  <td>{{(rawData[field.title][avg])? getFixed(rawData[field.title][avg][field.title]): ''}}</td>
                  <td>{{(rawData[field.title][groupLabels.length-1])? getFixed(rawData[field.title][groupLabels.length-1][field.title]): ''}}</td>
                </tr>
                <!-- <tr>
                  <td>{{groupLabels[0]}}</td>
                  <td
                    v-for="(field, index) in tableFields"
                    :key="'ptrend-first'+index"
                  >{{getFixed(rawData[field.title][0][field.title])}}</td>
                </tr>
                <tr>
                  <td>{{groupLabels[avg]}}</td>
                  <td
                    v-for="(field, index) in tableFields"
                    :key="'ptrend-mid'+index"
                  >{{getFixed(rawData[field.title][avg][field.title])}}</td>
                </tr>
                <tr>
                  <td>{{groupLabels[groupLabels.length-1]}}</td>
                  <td
                    v-for="(field, index) in tableFields"
                    :key="'ptrend-last'+index"
                  >{{getFixed(rawData[field.title][groupLabels.length-1][field.title])}}</td>
                </tr>-->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import Datepicker from "vuejs-datepicker";
import { commonMixins } from "../../assets/mixins/common.js";
var state = {
  disabledDates: {
    to: new Date(2016, 0, 5), // Disable all dates up to specific date
    from: new Date(2016, 0, 26), // Disable all dates after specific date
    days: [6, 0], // Disable Saturday's and Sunday's
    daysOfMonth: [29, 30, 31], // Disable 29th, 30th and 31st of each month
    dates: [
      // Disable an array of dates
      new Date(2016, 9, 16),
      new Date(2016, 9, 17),
      new Date(2016, 9, 18)
    ],
    ranges: [
      {
        // Disable dates in given ranges (exclusive).
        from: new Date(2016, 11, 25),
        to: new Date(2016, 11, 30)
      },
      {
        from: new Date(2017, 1, 12),
        to: new Date(2017, 2, 25)
      }
    ],
    // a custom function that returns true if the date is disabled
    // this can be used for wiring you own logic to disable a date if none
    // of the above conditions serve your purpose
    // this function should accept a date and return true if is disabled
    customPredictor: function(date) {
      // disables the date if it is a multiple of 5
      if (date.getDate() % 5 == 0) {
        return true;
      }
    }
  }
};
export default {
  props: ["isIndividual"],
  components: { Datepicker },
  mixins: [commonMixins],
  created() {
    // console.log("isIndividual", this.isIndividual);
    this.getCompaniesList();
  },
  methods: {
    getPdata() {
      // console.log("Ptype", this.ptype);
    },
    getRawData() {
      this.rawData = {};
      this.dataSets = [];
      let myself = this;
      http.post(
        this.rawDataApi + "/" + this.company.co_code,
        {
          from_date: this.getDate(this.fDate),
          to_date: this.getDate(this.toDate)
        },
        (error, response) => {
          // if (response.length > 0) {
          this.rawData = response;
          this.groupLabels = this.getChartData(this.rawData["p1_S"], "date");
          this.avg = Math.floor(this.groupLabels.length / 2);
          // console.log("Grouplabels", this.groupLabels);
          this.p1Data = this.getChartData(this.rawData["p1_S"], "p1_S");
          // console.log("p1Data", this.p1Data);
          this.p2Data = this.getChartData(this.rawData["p2_S"], "p2_S");
          this.p3Data = this.getChartData(this.rawData["p3_S"], "p3_S");
          this.p4Data = this.getChartData(this.rawData["p4_S"], "p4_S");
          this.p5_a_S = this.getChartData(this.rawData["p5_a_S"], "p5_a_S");
          this.p5_b_S = this.getChartData(this.rawData["p5_b_S"], "p5_b_S");
          this.p6_a = this.getChartData(this.rawData["p6_a"], "p6_a");
          this.p6_b = this.getChartData(this.rawData["p6_b"], "p6_b");
          this.p7_a_S = this.getChartData(this.rawData["p7_a_S"], "p7_a_S");
          this.p7_b_S = this.getChartData(this.rawData["p7_b_S"], "p7_b_S");
          this.p8_a_S = this.getChartData(this.rawData["p8_a_S"], "p8_a_S");
          this.p8_b_S = this.getChartData(this.rawData["p8_b_S"], "p8_b_S");
          this.p10_S = this.getChartData(this.rawData["p10_S"], "p10_S");
          this.p11_S = this.getChartData(this.rawData["p11_S"], "p11_S");
          this.q1_S = this.getChartData(this.rawData["q1_S"], "q1_S");
          this.q1_a_S = this.getChartData(this.rawData["q1_a_S"], "q1_a_S");
          this.q1_b_S = this.getChartData(this.rawData["q1_b_S"], "q1_b_S");
          this.q1_c_S = this.getChartData(this.rawData["q1_c_S"], "q1_c_S");
          this.q1_d_S = this.getChartData(this.rawData["q1_d_S"], "q1_d_S");
          this.p11_quarterly_trends = this.getChartData(
            this.rawData["p11_quarterly_trends"],
            "p11_quarterly_trends"
          );
          console.log("this.ptype", this.ptype)
          if (this.ptype.length > 0) this.getDataSets();
        }
        // }
      );
    },
    getChartData(data, field) {
      var cData = [];
      data.forEach((val, key) => {
        if (field === "date") {
          var date1 = this.getFormattedDate(val[field]);
          cData.push(date1);
        } else {
          cData.push(this.getFixed(val[field]));
        }
      });
      return cData;
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          if (!localStorage.getItem("selcomp")) {
            _this.selComp = _this.companyList[0];
            localStorage.setItem("selcomp", JSON.stringify(_this.selComp));
          } else {
            _this.selComp = JSON.parse(localStorage.getItem("selcomp"));
          }
          // console.log("Selected Comp", typeof _this.selComp);
          // setTimeout(() => {
          _this.company.companyname = _this.selComp.companyname;
          _this.company.co_code = _this.selComp.co_code;
          // });
        }
      });
    },
    getCompRawData() {
      // console.log("Get RawData", this.selComp);
      if (this.selComp !== "") {
        localStorage.setItem("selcomp", JSON.stringify(this.selComp));
        this.company.companyname = this.selComp.companyname;
        this.company.co_code = this.selComp.co_code;
        // console.log(
        //   "Company",
        //   this.company.co_code,
        //   "=>",
        //   this.company.companyname
        // );
        // this.getTabData(this.selRowInd, {}, {});
        this.getRawData();
      }
    },
    getFDate(e) {
      if (new Date(e) > this.toDate) {
        this.$toastr.error("From date must be smaller than To date");
        this.fDate = new Date().setDate(1);
      }
    },
    getToDate(e) {
      if (new Date(e) < this.fDate) {
        this.$toastr.error("From date must be smaller than To date");
        this.toDate = new Date().setDate(new Date().getDate - 1);
      }
    },
    plotGraph() {
      // console.log("Plot");
      if (this.selComp !== "") {
        // console.log("SelectedCompany");
        setTimeout(() => {
          this.configureChart();
        }, 1000);
      }
    },
    configureChart() {
      this.graphOptions["plugins"] = {
        datalabels: {
          display: false,
          align: "top",
          anchor: "end"
        }
      };
      // this.getDataSets();
      // var ctx = document.getElementById("comprice").getContext("2d");
      var comPriceChartContent = document.getElementById("ptrend");
      var graphId = this.graphId;
      comPriceChartContent.innerHTML = "&nbsp;";
      $("#ptrend").append('<canvas id="comprice"><canvas>');
      var ctx = $("#comprice")
        .get(0)
        .getContext("2d");
      var chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.groupLabels,
          datasets: this.dataSets
        },
        // Configuration options go here
        options: this.graphOptions
      });
      chart.update();
    },
    getDataSets() {
      var dataSets = [];
      this.ptype.forEach((val, ind) => {
        this.selPtype.push(val.title);
        dataSets.push({
          label: val.name,
          backgroundColor: "transparent",
          borderColor: val.backgroundColor,
          pointBackgroundColor: "#ffffff",
          data: this[val.data]
        });
      });
      // console.log("dataSets", dataSets);
      this.dataSets = dataSets;
      this.plotGraph();
    }
  },
  data() {
    return {
      tableFields: [
        {
          title: "p1_S",
          name: "P1",
          data: "p1Data",
          backgroundColor: "rgb(81, 143, 212)"
        },
        {
          title: "p2_S",
          name: "P2",
          data: "p2Data",
          backgroundColor: "rgb(227, 175, 100)"
        },
        {
          title: "p3_S",
          name: "P3",
          data: "p3Data",
          backgroundColor: "rgb(220,53,69)"
        },
        {
          title: "p4_S",
          name: "P4",
          data: "p4Data",
          backgroundColor: "rgb(111,66,193)"
        },
        {
          title: "p5_a_S",
          name: "P5 A",
          data: "p5_a_S",
          backgroundColor: "rgb(40,167,69)"
        },
        {
          title: "p5_b_S",
          name: "P5 B",
          data: "p5_b_S",
          backgroundColor: "rgb(81, 143, 212)"
        },
        {
          title: "p6_a",
          name: "P6 A",
          data: "p6_a",
          backgroundColor: "rgb(52,58,64)"
        },
        {
          title: "p6_b",
          name: "P6 B",
          data: "p6_b",
          backgroundColor: "rgb(255,193,7)"
        },
        {
          title: "p7_a_S",
          name: "P7 A",
          data: "p7_a_S",
          backgroundColor: "rgb(23,162,184)"
        },
        {
          title: "p7_b_S",
          name: "P7 B",
          data: "p7_b_S",
          backgroundColor: "rgb(253,126,20)"
        },
        {
          title: "p8_a_S",
          name: "P8 A",
          data: "p8_a_S",
          backgroundColor: "rgb(32,201,151)"
        },
        {
          title: "p8_b_S",
          name: "P8 B",
          data: "p8_b_S",
          backgroundColor: "rgb(232,62,140)"
        },
        {
          title: "p10_S",
          name: "P10",
          data: "p10_S",
          backgroundColor: "rgb(134,142,150)"
        },
        {
          title: "p11_S",
          name: "P11",
          data: "p11_S",
          backgroundColor: "rgb(253,126,20)"
        },
        { title: "q1_S", name: "Q1", data: "q1_S", backgroundColor: "#6f42c1" },
        {
          title: "q1_a_S",
          name: "Q1 A",
          data: "q1_a_S",
          backgroundColor: "rgb(111,66,193)"
        },
        {
          title: "q1_b_S",
          name: "Q1 B",
          data: "q1_b_S",
          backgroundColor: "rgb(81, 143, 212)"
        },
        {
          title: "q1_c_S",
          name: "Q1 C",
          data: "q1_c_S",
          backgroundColor: "rgb(52,58,64)"
        },
        {
          title: "q1_d_S",
          name: "Q1 D",
          data: "q1_d_S",
          backgroundColor: "rgb(134,142,150)"
        },
        {
          title: "p11_quarterly_trends",
          name: "Quarterly Trend",
          data: "p11_quarterly_trends",
          backgroundColor: "rgb(40,167,69)"
        }
      ],
      fDate: new Date().setDate(1),
      toDate: new Date().setDate(new Date().getDate() - 1),
      minDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      companyList: [],
      selComp: "",
      ptype: [],
      selPtype: [],
      dataSets: [],
      company: { co_code: "", companyname: "" },
      rawDataApi: "getPTrends",
      rawData: {},
      groupLabels: [],
      p1Data: [],
      p2Data: [],
      p3Data: [],
      p4Data: [],
      p5_a_S: [],
      p5_b_S: [],
      p6_a: [],
      p6_b: [],
      p7_a_S: [],
      p7_b_S: [],
      p8_a_S: [],
      p8_b_S: [],
      p10_S: [],
      p11_S: [],
      q1_S: [],
      q1_a_S: [],
      q1_b_S: [],
      q1_c_S: [],
      q1_d_S: [],
      p11_quarterly_trends: [],
      avg: 0,
      graphOptions: {
        maintainAspectRatio: true,
        responsive: true,
        legend: {
          display: true,
          position: "right",
          reverse: false
        },
        // tooltips: {
        //   mode: "index",
        //   intersect: false
        // },
        // hover: {
        //   mode: 'nearest',
        //   intersect: true
        // },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              // ticks: {
              //   beginAtZero: true
              // },
              display: true,
              gridLines: {
                display: false,
                zeroLineColor: "#e8e9ef",
                color: "#e8e9ef",
                drawBorder: true
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 1,
            borderWidth: 2
          }
        }
      }
    };
  },
  mounted() {},
  watch: {
    data: function() {
      this._chart.destroy();
      // this.configureChart();
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>
// if(this.checkInArray(this.selPtype, 'p1_S')){
      //   dataSets.push(
      //     {
      //         label: "P1",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(81, 143, 212)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p1Data
      //       });
      // } else if(){}
      // dataSets.push(
      //     {
      //         label: "P1",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(81, 143, 212)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p1Data
      //       },
      //       {
      //         label: "P2",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(227, 175, 100)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p2Data
      //       },
      //       {
      //         label: "P3",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(220,53,69)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p3Data
      //       },
      //       {
      //         label: "P4",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(111,66,193)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p4Data
      //       },
      //       {
      //         label: "P5 A",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(40,167,69)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p5_a_S
      //       },
      //       {
      //         label: "P5 B",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(81, 143, 212)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p5_b_S
      //       },
      //       {
      //         label: "P6 A",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(52,58,64)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p6_a
      //       },
      //       {
      //         label: "P6 B",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(255,193,7)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p6_b
      //       },
      //       {
      //         label: "P7 A",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(23,162,184)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p7_a_S
      //       },
      //       {
      //         label: "P7 B",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(253,126,20)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p7_b_S
      //       },
      //       {
      //         label: "P8 A",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(32,201,151)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p8_a_S
      //       },
      //       {
      //         label: "P8 B",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(232,62,140)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p8_b_S
      //       },
      //       {
      //         label: "P10",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(134,142,150)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p10_S
      //       },
      //       {
      //         label: "P11",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(253,126,20)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.p11_S
      //       },
      //       {
      //         label: "Q1",
      //         backgroundColor: "transparent",
      //         borderColor: "#6f42c1",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.q1_S
      //       },
      //       {
      //         label: "Q1 A",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(81, 143, 212)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.q1_a_S
      //       },
      //       {
      //         label: "Q1 B",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(111,66,193)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.q1_b_S
      //       },
      //       {
      //         label: "Q1 C",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(52,58,64)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.q1_c_S
      //       },
      //       {
      //         label: "Q1 D",
      //         backgroundColor: "transparent",
      //         borderColor: "rgb(134,142,150)",
      //         pointBackgroundColor: "#ffffff",
      //         data: this.q1_d_S
      //       },
      // );


// WEBPACK FOOTER //
// src/views/company/pTrends.vue